import fetch from './api'
// 账号管理模块

// 账号列表
const PACKAGEISVALID = params => {
    return fetch({
        url: '/package/manage/isValid',
        method: 'get',
        params: params
    })
}
// 发送手机验证码
const GETCODE = params => {
    // test.tiku.eoffcn.com
    return fetch({
        //url: 'http://test.tiku.eoffcn.com/user/register/getCode',
        url: 'https://tiku.eoffcn.com/user/register/getCode',
        method: 'get',
        params: params,
        Origin: 'https://nwn.eoffcn.com'
    })
}
// 验证手机验证码
const VALIDCODE = params => {
    // test.tiku.eoffcn.com
    return fetch({
        //url: 'http://test.tiku.eoffcn.com/user/register/checkCode',
        url: 'https://tiku.eoffcn.com/user/register/checkCode',
        method: 'get',
        params: params,
        Origin: 'https://nwn.eoffcn.com'
    })
}
// 领取学习包
const ADDPACKAGE = params => {
    // test.tiku.eoffcn.com
    return fetch({
        url: '/package/manage/addUserPackage',
        method: 'get',
        params: params
    })
}
export default {
    PACKAGEISVALID,
    GETCODE,
    VALIDCODE,
    ADDPACKAGE,
}


// WEBPACK FOOTER //
// ./src/api/interface-active.js